export enum CheckoutCardProvider {
  Paysafe = 'paysafe',
  Worldpay = 'worldpay',
}
